module.exports = __webpack_public_path__ + "img/RecoveryApp.b2fdf31a.png";